module.exports = __webpack_public_path__ + "fa-solid-900.woff2?d824df7eb2e268626a2dd9a6a741ac4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-solid-900.woff2
// module id = 1456
// module chunks = 0